import React from 'react';

import { EmptyState } from 'epoch-components/EmptyState/EmptyState';
import SurveyTemplateIcon from 'components/common/icons/SurveyTemplateIcon';

import { CreateTemplateButton } from '../tabs/EditEventFeedback/components/CreateTemplateButton';

interface EmptyTemplateStateProps {
  searchText: string;
}

export const EmptyTemplateState: React.FC<EmptyTemplateStateProps> = ({ searchText }) => (
  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12">
    {searchText ? (
      <EmptyState />
    ) : (
      <>
        <SurveyTemplateIcon large />
        <p className="tw-mt-2 tw-text-sm tw-font-medium tw-text-primary-grey">
          No templates added yet
        </p>
        <p className="tw-text-sm tw-text-primary-grey">
          <CreateTemplateButton className="tw-mt-4" />
        </p>
      </>
    )}
  </div>
);
